
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import Title from './Title/index.vue'
import LazyImg from '@/components/lazyImg/index.vue'
import { Observer } from 'mobx-vue'

@Observer
@Component({
  components: {
    Title,
    LazyImg
  }
})
export default class MyAccount extends Vue {
  accountBackgroundImgList: string[] = [
    this.$images.my_classroom_order,
    this.$images.my_classroom_coupon,
    this.$images.my_classroom_exchange
  ]

  get UserInfo() {
    return this.$store.$storeUser.UserInfo
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
